import * as React from 'react'
import * as moment from 'moment'
import { Link } from 'react-router-dom'
import { MoonLoader } from 'react-spinners'
import UserTopPanel from '../../containers/trips/UserTopPanel'
import Copy from '../icons/ui/Copy'
import ImageView from '../ui/ImageView'
import StatusTag from '../ui/StatusTag'
import { IRecentTripObj, IRecentTrips, IRiderObject, IRiderTrip } from '../../types'
import UIMessages from 'src/utils/ui-messages'

interface IItemProps {
  trip: IRecentTripObj
  cloneTrip: (trip: IRiderTrip) => Promise<any>
}
class RecentTripItem extends React.Component<IItemProps> {
  private tripLink: any

  public render() {
    console.log('RIDER RECENT TRIPS CALLED')

    const { trip } = this.props
    const tripRider = trip.rider
    const status = trip.lastStatus
    const statusAt = trip.lastStatusAt
    const pickup = (trip.pickupLocation && trip.pickupLocation.fullAddress) || ''
    const dropoff = (trip.dropoffLocation && trip.dropoffLocation.fullAddress) || ''

    return (
      <div className='flex justify-between cursor--pointer'>
        <div key={`${trip.id}-${trip.service.serviceId}`} onClick={this.selectTrip}>
          <div className='flex items-center'>
            <ImageView entityId={trip.service.serviceId} width='30px' height='30px' />
            <Link className='' to={`/trips/${trip.id}`} ref={this.attachRef}>
              <p className='mt0 mb0 ml1 bold font-black'>{trip.service.name}</p>
            </Link>
          </div>
          <div className='flex items-center'>
            <span className=''>{pickup.split(',')[0]}</span>
            <span className='font-black mr1 ml1'>&#8594;</span>
            <span className=''>{dropoff.split(',')[0]}</span>
          </div>
          {status ? (
            <div className='flex items-center'>
              <p className='mt0 mb0 mr2'>
                <StatusTag status={status} />
              </p>
              <p className='m0 h6 bold font-blue'>{moment(statusAt).fromNow()}</p>
            </div>
          ) : null}
          <div className='flex items-center mb2'>
            <span>{trip.product.name}</span>
          </div>
        </div>
        <Link className='' to='#' onClick={this.copyTrip(trip)}>
          <Copy className='ml1' />
        </Link>
      </div>
    )
  }

  private copyTrip = (trip: IRiderTrip) => (e: any) => {
    this.props.cloneTrip(trip)
  }

  private selectTrip = (e: any) => {
    this.tripLink.handleClick(e)
  }

  private attachRef = (node: any) => {
    this.tripLink = node
  }
}

interface IRecentTripsProps {
  isFetching: boolean
  riderId: string
  currentOrganizationId: string
  recentTrips: IRecentTrips
  getRecentTrips: (riderId: string, orgId: string) => Promise<any>
  cloneTrip: (trip: IRiderTrip) => Promise<any>
  resetTripRiders: () => void
}

class RecentTrips extends React.Component<IRecentTripsProps> {
  public componentDidMount() {
    const { riderId, currentOrganizationId } = this.props
    this.props.getRecentTrips(riderId, currentOrganizationId)
  }
  public resetState = () => {
    alert('RESET STATE')
  }
  public render() {
    const { riderId, recentTrips, isFetching } = this.props
    return (
      <React.Fragment>
        <UserTopPanel riderId={riderId} />
        <div className='flex justify-center'>
          <Link
            className='btn rounded bg-blue font-white'
            to={`/trips/create/${riderId}`}
            onClick={this.props.resetTripRiders}
          >
            {UIMessages.rider.bookNewRide}
          </Link>
        </div>
        <div className='flex justify-center'>
          <MoonLoader sizeUnit={'px'} size={27} color={'#405264'} loading={isFetching} />
        </div>
        {!isFetching && recentTrips ? (
          <div className='pl2 pr2 overflow-y-scroll trip-pane-content'>
            <h3>{UIMessages.rider.upcoming}</h3>
            {this.renderToday()}
            <h3>{UIMessages.rider.recent}</h3>
            {this.renderRecent()}
          </div>
        ) : null}
      </React.Fragment>
    )
  }

  private renderToday = () => {
    const trips = this.props.recentTrips.today
    if (!trips.length) {
      return (
        <div className='flex justify-center'>
          <p>No trips today</p>
        </div>
      )
    }
    return (
      <div className='pl2'>
        {trips.map(t => {
          return <RecentTripItem key={t.id} trip={t} cloneTrip={this.props.cloneTrip} />
        })}
      </div>
    )
  }

  private renderRecent = () => {
    const trips = this.props.recentTrips.recent
    if (!trips.length) {
      return (
        <div className='flex justify-center'>
          <p>No recent trips</p>
        </div>
      )
    }
    return (
      <div className='pl2'>
        {trips.map(t => {
          return <RecentTripItem key={t.id} trip={t} cloneTrip={this.props.cloneTrip} />
        })}
      </div>
    )
  }
}
export default RecentTrips



// WEBPACK FOOTER //
// ./src/components/trips/RiderRecentTrips.tsx